import { render, staticRenderFns } from "./project-appropriations.html?vue&type=template&id=b6cd77b0&"
import script from "./ProjectAppropriations.vue?vue&type=script&lang=js&"
export * from "./ProjectAppropriations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports